<script>
import Order from '@/models/Order';
import orderComponent from '@/components/order/order.vue';
import modalOrderComponent from '@/components/modals/create_order/create_order.vue';
import modalOrderEditComponent from '@/components/modals/edit_order/edit_order.vue';
import modalSetConditionComponent from '@/components/modals/set_condition/set_condition.vue';
import modalOrderProductsComponent from '@/components/modals/order_products/order_products.vue';

export default {
  data() {
    return {
      showAddOrderModal: false,
      placeholder_text: 'Search by asin, tracking number, product title, order comment, client comment',
      filters: {
        search: '',
      },
    };
  },
  computed: {
    orders() {
      return this.$store.state.inBound.orders;
    },
    loaded() {
      return this.$store.state.inBound.loaded;
    },
    modal_asin() {
      return this.$store.state.inBound.instock_modal_asin;
    },
    modal_edit() {
      return this.$store.state.inBound.instock_modal_order;
    },
    modal_order_edit() {
      return this.$store.state.inBound.instock_modal_order_edit;
    },
    modal_create() {
      return this.$store.state.inBound.instock_modal_order_products;
    },
    user_role() {
      return this.$store.state.users.role;
    },
    chosen_client() {
      return this.$store.state.users.chosen_client;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    filteredOrders() {
      if (this.orders.length === 0) {
        return [];
      }

      return this.orders.filter((order) => {
        const asin = (order.products.filter((product) => {
          if (product.asin) {
            product.asin.toLowerCase().includes(this.filters.search.toLowerCase());
          }

          return false;
        })).length > 0;

        const trackNumber = order.track_number.toLowerCase().includes(
          this.filters.search.toLowerCase(),
        );

        const productClientComment = (order.products.filter((product) => {
          if (product.client_comment === null) return false;

          return product.client_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        const productTitle = (order.products.filter((product) => (
          product.title.toLowerCase().includes(this.filters.search.toLowerCase())
        ))).length > 0;

        let clientComment = null;

        if (order.client_comment !== null) {
          clientComment = order.client_comment.toLowerCase().includes(
            this.filters.search.toLowerCase(),
          );
        }

        return asin || productTitle || trackNumber || productClientComment || clientComment;
      });
    },
  },
  created() {
    this.$store.dispatch('ib_set_loaded', false);

    if (['admin', 'worker'].indexOf(this.user_role) !== -1 && !this.chosen_client) {
      this.$router.push({ name: `${this.app_section}-clients` });
      return;
    }
    this.$store.dispatch('ib_load_orders');
  },
  components: {
    order_component: orderComponent,
    modal_order__component: modalOrderComponent,
    modal_set_condition__component: modalSetConditionComponent,
    modal_order_products__component: modalOrderProductsComponent,
    modal_order_edit__component: modalOrderEditComponent,
  },
  methods: {
    newOrder() {
      this.$store.commit('set_instock_modal_order', new Order());
    },
    set_search(str) {
      this.filters.search = str;
    },
  },
};
</script>
<template src="./in-bound.pug" lang="pug"></template>
